import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonButton, IonGrid, IonRow, IonCol } from '@ionic/vue';


const __default__ = { inheritAttrs: false };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MyButtonBase',
  props: {
  pulse: { type: Boolean, default: false },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonGrid), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRow), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButton), _mergeProps({
                class: ["ion-button-class ion-text-wrap", { pulsed: __props.pulse }]
              }, _ctx.$attrs, {
                shape: "round",
                style: {"--box-shadow":"none"}
              }), {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              }, 16, ["class"])
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})